import React from "react";
import errorImage from "../assets/Images/personSorry.png";
import { useNavigate } from "react-router-dom";

const Error = () => {
  const navigate = useNavigate();
  return (
    <div
      className="flex flex-col w-full bg-richblack-900
     text-[#c6c1bb] min-h-[91vh] justify-center gap-5 items-center 
     lg:bg-errorImage bg-blend-multiply bg-bottom bg-no-repeat overflow-y-hidden bg-fill  "
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <img src={errorImage} alt="" className="lg:w-1/3 md:w-1/2 w-4/5 -mt-16"/>
        <p className="text-2xl">Requested URL cannot be found</p>
        <button
          className="text-[15px] font-inter bg-[#7e6fcd] p-3 rounded-xl  font-bold
         active:scale-95 shadow-[inset_-1px_-1px_0px_1px_#FFFFFF82]"
          onClick={() => {
            navigate(-1);
          }}
        >
           Back
        </button>
      </div>
    </div>
  );
};

export default Error;
